import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import logo from "../../assets/logo.png";

// Hooks y Componentes refactorizados
import { useProductosGrupales } from "./hooks/useProductosGrupales";
import { ProductTable } from "./Sections/ProductTable";
import { ProductDetailSheet } from "./Sections/ProductDetailSheet";
import { DeleteConfirmDialog } from "./Sections/DeleteConfirmDialog";
import { SenaPasajeros } from "./Sections/SenaPasajeros";

interface ProductosGrupalesProps {
  category?: string;
  terminoBusqueda?: string;
  refreshTrigger?: number;
  modoVisualizacion?: "vigentes" | "finalizados";
}

const getCategoryPalette = (_cat?: string) => {
  return {
    main: "#461264", // Morado oscuro (Vittorio)
    light: "#f4eff7", // Fondo ultra suave morado
    gradient: "linear-gradient(135deg, #461264 0%, #6a1b9a 100%)", // Gradiente moderno
  };
};

export const ProductosGrupales: React.FC<ProductosGrupalesProps> = ({
  category,
  terminoBusqueda = "",
  refreshTrigger = 0,
  modoVisualizacion = "vigentes",
}) => {
  const palette = getCategoryPalette(category);
  
  const {
    productosFiltrados,
    cargando,
    dialogoAbierto,
    setDialogoAbierto,
    fichaAbierta,
    setFichaAbierta,
    productoSeleccionado,
    senaAbierta,
    setSenaAbierta,
    productoEnSena,
    nuevoPasajero,
    setNuevoPasajero,
    guardandoCambios,
    cargarProductos,
    handleViewProduct,
    handleProductSheetClose,
    handleDeleteProduct,
    confirmDeleteProduct,
    guardarCambios,
    actualizarProductoSeleccionado,
    eliminarPasajero,
    onAddPassenger,
    onUpdatePassenger,
    handleOpenSena,
    handleUpdateMontoSena,
    handleAddPagoPasajero,
    handleUpdatePagoEstudiante,
    handleEliminarPagoEstudiante,
    handleToggleRevisadoEstudiante,
    handleFinalizarProducto,
  } = useProductosGrupales({
    category,
    terminoBusqueda,
    refreshTrigger,
    modoVisualizacion,
  });

  const formatearMoneda = (valor: number, moneda: string = "ARS"): string => {
    if (moneda === "ARS") {
      return `$ ${valor.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
    return `U$D ${valor.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ProductTable
        productosFiltrados={productosFiltrados}
        cargando={cargando}
        palette={palette}
        category={category}
        modoVisualizacion={modoVisualizacion}
        cargarProductos={cargarProductos}
        handleViewProduct={handleViewProduct}
        handleOpenSena={handleOpenSena}
        handleDeleteProduct={handleDeleteProduct}
      />

      <ProductDetailSheet
        open={fichaAbierta}
        onClose={handleProductSheetClose}
        productoSeleccionado={productoSeleccionado}
        palette={palette}
        logo={logo}
        category={category}
        actualizarProductoSeleccionado={actualizarProductoSeleccionado}
        guardarCambios={guardarCambios}
        guardandoCambios={guardandoCambios}
        nuevoPasajero={nuevoPasajero}
        setNuevoPasajero={setNuevoPasajero}
        eliminarPasajero={eliminarPasajero}
        onAddPassenger={onAddPassenger}
        onUpdatePassenger={onUpdatePassenger}
        onFinalizar={handleFinalizarProducto}
        onDeleteProduct={handleDeleteProduct}
        onOpenPagos={handleOpenSena}
        onAddPagoPasajero={handleAddPagoPasajero}
        onUpdatePagoPasajero={handleUpdatePagoEstudiante}
        onDeletePagoPasajero={handleEliminarPagoEstudiante}
        onToggleRevisadoPagoPasajero={handleToggleRevisadoEstudiante}
      />

      {productoEnSena && (
        <SenaPasajeros
          open={senaAbierta}
          onClose={() => setSenaAbierta(false)}
          producto={productoEnSena}
          onUpdateMontoSena={handleUpdateMontoSena}
          onAddPagoPasajero={handleAddPagoPasajero}
          onUpdatePagoPasajero={handleUpdatePagoEstudiante}
          onDeletePago={handleEliminarPagoEstudiante}
          onToggleRevisado={handleToggleRevisadoEstudiante}
        />
      )}

      <DeleteConfirmDialog
        open={dialogoAbierto}
        onClose={() => setDialogoAbierto(false)}
        onConfirm={confirmDeleteProduct}
      />
    </LocalizationProvider>
  );
};

export default ProductosGrupales;
